module.exports = __webpack_public_path__ + "img/upheader.ebcdfcde.svg";